export const DynmicFormFieldType = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  DECIMAL: 'DECIMAL',
  COMBO: 'COMBO',
  DATE: 'DATE',
  LONGTEXT: 'LONG_TEXT',
  STATIC: 'STATIC',
};

export const DynmicFormFieldTypeOptions = [
  { label: 'Szöveges', value: DynmicFormFieldType.TEXT },
  { label: 'Hosszú szöveges', value: DynmicFormFieldType.LONGTEXT },
  //{ label: 'Egész szám', value: DynmicFormFieldType.NUMBER },
  { label: 'Szám', value: DynmicFormFieldType.DECIMAL },
  { label: 'Választólista', value: DynmicFormFieldType.COMBO },
  //{ label: 'Dátum', value: DynmicFormFieldType.DATE },
  { label: 'Statikus szöveg', value: DynmicFormFieldType.STATIC },
];
